import React from 'react';
import { useSelector } from 'react-redux';
import SyncfusionTooltip from './SyncfusionTooltip';

const Tooltip = (props) => {
    const { isAuth } = useSelector(state => state.auth);

    if (!isAuth) {
        return <div className="target" title={props.text}>{props.children}</div>;
    }

    return <SyncfusionTooltip {...props} />;
};

export default Tooltip;
